var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c(
        "div",
        [_c("LoadingSpinner", { attrs: { message: "Cargando datos" } })],
        1
      )
    : _c(
        "div",
        { staticClass: "form-body" },
        [
          _c("b-breadcrumb", { attrs: { items: _vm.getBreadCrumbItems } }),
          _c(
            "b-card",
            [
              _c("h3", [_c("span", [_vm._v("Etiqueta")])]),
              _c("InfoTag", { attrs: { tag: _vm.tag, editMode: false } }),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }